import { render, staticRenderFns } from "./EditAdDestination.vue?vue&type=template&id=45799b00&scoped=true&"
import script from "./EditAdDestination.vue?vue&type=script&lang=ts&"
export * from "./EditAdDestination.vue?vue&type=script&lang=ts&"
import style0 from "./EditAdDestination.vue?vue&type=style&index=0&id=45799b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45799b00",
  null
  
)

export default component.exports